module.exports = __webpack_public_path__ + "static/media/zETH.199533b1.png";